import { Experiment, Recipe } from 'site-modules/shared/components/experiment';
import React from 'react';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { URL_CONTEXT_PATH, UrlModel } from 'client/data/models/url';
import PropTypes from 'prop-types';

function Shop3947ExperimentUI({ urlContext = undefined }) {
  if (!(urlContext?.location?.city || urlContext?.location?.stateCode)) {
    return null;
  }

  return (
    <Experiment name="shop-3947-city-state-zip" showDefault>
      <Recipe name="ctrl" isDefault />
      <Recipe name="chal" />
    </Experiment>
  );
}

Shop3947ExperimentUI.propTypes = {
  urlContext: PropTypes.shape({ location: PropTypes.shape({ city: PropTypes.string, stateCode: PropTypes.string }) }),
};

export const Shop3947Experiment = connectToModel(Shop3947ExperimentUI, {
  urlContext: bindToPath(URL_CONTEXT_PATH, UrlModel, null, false),
});
